import React, {Component} from 'react';
import SendMailComponentRender from './sendMailComponentRender';

export class SendMailComponent extends Component {
  render() {
    return <SendMailComponentRender {...this.props} />;
  }
}

export default SendMailComponent;
